import { createSlice } from '@reduxjs/toolkit';
import { WorkFromHome, WorkFromHomeState } from './workformhome.Types';
import { createWorkfromHome, UpdateWorkfromHome, fetchAllWorkformHome, DeleteWorkfromHome, getworkfromhomeById, fetchWorkFromHomeBySupervisorHierarchy } from './workfromhome.action';



const initialState: WorkFromHomeState = {
    workfromhome: [],
    workformhomeBySupervisor: [],
    selectedworkfromhome: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchBySupervisor: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchBySupervisor: undefined,
        fetchAll: undefined,
    },
}


const WorkformhomeSlice = createSlice({
    name: 'workfromhome',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createWorkfromHome.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createWorkfromHome.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.workfromhome.push(action.payload);
            })
            .addCase(createWorkfromHome.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update 
            .addCase(UpdateWorkfromHome.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(UpdateWorkfromHome.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.workfromhome.findIndex((d: any) => d.Id === action.payload.Id);
                if (index !== -1) {
                    state.workfromhome[index] = action.payload;
                }
            })
            .addCase(UpdateWorkfromHome.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete 
            .addCase(DeleteWorkfromHome.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(DeleteWorkfromHome.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.workfromhome = state.workfromhome.filter((d: any) => d.Id !== action.payload);
            })
            .addCase(DeleteWorkfromHome.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch  by ID
            .addCase(getworkfromhomeById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(getworkfromhomeById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedworkfromhome = action.payload;
            })
            .addCase(getworkfromhomeById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All 
            .addCase(fetchAllWorkformHome.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllWorkformHome.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.workfromhome = action.payload.data;
            })
            .addCase(fetchAllWorkformHome.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            })

    // Fetch By Supervisor Hierarchy
      .addCase(fetchWorkFromHomeBySupervisorHierarchy.pending, (state) => {
        state.loadingStates.fetchBySupervisor = true;
        state.errors.fetchBySupervisor = undefined;
      })
      .addCase(fetchWorkFromHomeBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loadingStates.fetchBySupervisor = false;
        state.workformhomeBySupervisor = action.payload.data;
      })
      .addCase(fetchWorkFromHomeBySupervisorHierarchy.rejected, (state, action) => {
        state.loadingStates.fetchBySupervisor = false;
        state.errors.fetchBySupervisor = action.payload as string;
      });

    },
})

export default WorkformhomeSlice.reducer;